import { Epic } from 'redux-observable';
import { Observable } from 'rxjs';

import { Action } from '../actions';
import {
    onUpdateCampaignDayBudgetInfo,
    UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE,
    UpdateCampaignDayBudget,
    UpdateCampaignDayBudgetInfoRemoteAction
} from '../actions/campaigns-grid';
import { DummyAction, dummyAction } from '../actions/common';
import {
    deleteEditCellData,
    DeteleEditCellData,
    UpdateEditCellData,
    updateEditCellData
} from '../actions/grid-screen';
import { selectGridSourceParams } from '../selectors/gridSourceParams/gridSourceParams';
import { EpicDeps } from '../service/StoreFactory';
import { State } from '../typings/state';

type UpdateCampaignDayBudgetEpicObservable = Observable<
    | DummyAction
    | DeteleEditCellData
    | UpdateEditCellData
    | UpdateCampaignDayBudget
>;

export const updateCampaignDayBudgetEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.ofType(UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE).mergeMap(
        (
            action: UpdateCampaignDayBudgetInfoRemoteAction
        ): UpdateCampaignDayBudgetEpicObservable => {
            const state = store$.value;
            const sourceParams = selectGridSourceParams(state);
            const { value, campaignId } = action.params;
            if (!sourceParams || !value) {
                return Observable.of(dummyAction);
            }

            const { login, view } = sourceParams;
            const cellKey = {
                ...action.cellKeyPartial,
                view: view
            };

            return Observable.fromPromise(
                deps.restApiManager.saveCampaignDayBudget(
                    value,
                    campaignId,
                    login
                )
            )
                .mergeMap(() =>
                    Observable.concat(
                        Observable.of(deleteEditCellData(cellKey)),
                        Observable.of(
                            onUpdateCampaignDayBudgetInfo(action.params)
                        )
                    )
                )
                .catch(error =>
                    Observable.of(
                        updateEditCellData(cellKey, {
                            isSaving: false,
                            error: error.getMessage()
                        })
                    )
                );
        }
    );
};
